/*
    planReducer
    Creates an obj with this shape for /subscription/v2 endpoint
    {
        planSize: "1-2",
        plans: [
            {id: 3}, // Fruit
            {id: 4}, // Veg
            {id: 9, subPlanIDs: [13, 14]} // Meat plan with poultry and beef sub plans selected
        ]
    }
    See: https://misfitsmarket.atlassian.net/wiki/spaces/TECH/pages/2516779115/Plans+2.0
*/

const planReducer = (state, action) => {
    switch (action.type) {
        case 'setPlanSize':
            return {
                ...state,
                planSize: action.payload,
            };
        case 'addPlan':
            return {
                ...state,
                plans: [...state.plans, action.payload],
            };
        case 'removePlan':
            return {
                ...state,
                plans: state.plans.filter((plan) => plan.id !== action.payload),
            };
        case 'modifyPlan':
            return {
                ...state,
                plans: state.plans.map((plan) => (plan.id === action.payload.id ? action.payload : plan)),
            };

        default:
            throw new Error('plansReducer default hit.');
    }
};

export default planReducer;
